import { MenuInterface } from 'src/app/_core/components/layout-nav/routes';

export const activitySettingsFormsRoutes: MenuInterface[] = [
    {
        code: 'Forms',
        route: [
            {
                content: '$type/settings/forms/list',
                focus: 'empty'
            }, {
                primaryRoute: 'content',
                queryParams: {closeButton: 1}
            }
        ]
    }
]
